module.exports = __webpack_public_path__ + "static/media/skiBoots.7c7f4a39.svg";